import { SVGProps } from "react";

export const Icon = ({
  svg,
  width = 20,
  height = 20,
  className,
  onClick,
  ...props
}: {
  svg: string;
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
} & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      onClick={onClick}
      className={`min-w-fit ${className}`}
      width={width ? width : 20}
      height={height ? height : 20}
      {...props}
    >
      <use href={`/assets/icons_sprite.svg#${svg}`}></use>
    </svg>
  );
};
